import IframeActivity from "./IframeActivity";

export default function EmotionalIntelligence() {
    return (
        <IframeActivity
            src="/activities/emotional-intelligence/index.html"
            title="Emotional Intelligence"
        />
    );
}